import BadSide from "../../assets/img/new-home-page/slider/Badside.png";
import Sidelines from "../../assets/img/new-home-page/slider/sidelines.png";
import Ambulance from "../../assets/img/new-home-page/slider/Ambulance.png";
import ER from "../../assets/img/new-home-page/slider/ER.png";
import OldHome from "../../assets/img/new-home-page/slider/Old-home.png";
import PATENT_THUMBNAIL from "../../assets/img/new-home-page/patent-thumbnail.png";
import VALIDATED_SIGNAL from "../../assets/img/new-home-page/validated-signal.png";

const WHITEPAPER_URL =
  "https://doctors-images.s3.amazonaws.com/PenEEG-Whitepaper.pdf";
const PATENT_URL = "https://doctors-images.s3.amazonaws.com/US-12629079-B2.pdf";

const gridItems = [
  {
    src: VALIDATED_SIGNAL,
    title: "Validated Signal",
    description:
      "A handheld, 2-channel device that captures brain-rhythm data at the point of care. Our whitepaper demonstrates how PenEEG™ signal was evaluated across three phases: bench, live clinical side-by-side, and first-time operators.",
    buttonText: "View whitepaper",
    buttonColor: "#00A9AC",
    href: WHITEPAPER_URL,
    target: "_blank",
  },
  {
    src: PATENT_THUMBNAIL,
    title: "PenEEG™ patent",
    description:
      "Patent covers repositionable EEG acquisition — handheld form factor, software-guided placement, and use outside of traditional clinical environments.",
    buttonText: "View patent",
    buttonColor: "#FF52B0",
    href: PATENT_URL,
    target: "_blank",
  },
  // {
  //   src: Ambulance,
  //   title: "Emergency",
  //   description:
  //     "CenSyn PenEEG™ can be used during remote emergency monitoring to collect real-time brain data outside the hospital to accelerate treatments.",
  //   buttonText: "Case study coming soon",
  //   buttonColor: "#B4B4B4",
  // },
];

const GridLayout = () => {
  return (
    <div className="tw-px-4 sm:tw-px-6 md:tw-px-20">
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-16 tw-max-w-4xl tw-mx-auto">
        {gridItems.map((item, index) => (
          <div
            key={index}
            className="tw-bg-white tw-rounded-lg tw-overflow-hidden tw-transition-all tw-duration-300 tw-shadow-[0_8px_20px_rgba(0,0,0,0.08),0_20px_60px_rgba(0,0,0,0.12)] hover:tw-shadow-[0_12px_30px_rgba(0,0,0,0.12),0_30px_80px_rgba(0,0,0,0.18)] hover:tw-scale-[1.03]"
          >
            {/* Image Container */}
            <div className="tw-relative tw-h-56 tw-w-full tw-mt-6 tw-px-6">
              <div className="tw-rounded-lg tw-overflow-hidden tw-bg-white tw-h-full tw-w-full">
                <img
                  src={item.src}
                  alt={item.title}
                  className="tw-w-full tw-h-full tw-object-contain"
                />
              </div>
            </div>

            {/* Content Container */}
            <div className="tw-p-6 tw-mb-6">
              <h3 className="tw-text-xl tw-font-bold tw-mb-3 tw-text-gray-800">
                {item.title}
              </h3>
              <p className="tw-text-gray-600 tw-mb-4 tw-text-sm tw-leading-relaxed tw-min-h-[80px]">
                {item.description}
              </p>
              <a
                href={item.href}
                target={item.target}
                rel={
                  item.target === "_blank" ? "noopener noreferrer" : undefined
                }
                className="tw-text-white tw-px-6 tw-py-2 tw-rounded-full tw-font-semibold tw-text-sm tw-inline-block tw-text-center tw-bg-[#00A9AC] tw-no-underline hover:tw-text-white"
              >
                {item.buttonText}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GridLayout;
